/* eslint-disable react/jsx-boolean-value */
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';
import BookmarkLessonAction from '../../../../../lessons/lessonactions/BookmarkLessonAction';
import { useTeacherCourses } from '../../../../context/TeacherCourseContextProvider';

const defaultProps = {
  showLabel: false,
  className: '',
};

/**
 * Share Link Lesson Action Container
 */
export default function TeacherCourseLessonBookmarkAction(p) {
  const { lesson, className, showLabel } = { ...defaultProps, ...filterUndefined(p) };
  const { teacherCourseDomain } = useTeacherCourses();
  const {
    lessonData,
  } = teacherCourseDomain.domainData;
  return (
    <BookmarkLessonAction
      lesson={lesson}
      showLabel={showLabel}
      className={className}
      onSaveSuccess={() => {
        // eslint-disable-next-line no-param-reassign
        lesson.meta.assigned = true;
        // eslint-disable-next-line no-param-reassign
        lesson.meta.archived = false;
        teacherCourseDomain.updateLessonsData([...lessonData.lessons], lessonData.included);
      }}
    />
  );
}
